import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);      // null = unchecked or unauth, object = authed
  const [loading, setLoading] = useState(true);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("gt_admin_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await axios.get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${token}` } });
      setAdmin(data);
    } catch {
      localStorage.removeItem("gt_admin_token");
      setAdmin(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    localStorage.setItem("gt_admin_token", data.token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = () => {
    localStorage.removeItem("gt_admin_token");
    setAdmin(null);
  };

  const authFetch = async (method, path, body) => {
    const token = localStorage.getItem("gt_admin_token");
    return axios({
      method,
      url: `${API}${path}`,
      data: body,
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, authFetch }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
